import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_NEW_DOCTOR_VISIT_REPORT} from '@app/navigations/RoutePathConstant';

const NewDoctorVisitReports = lazy(() =>
  import('../../../screens/NewDoctorVisitReports')
    .then(module => ({default: module.NewDoctorVisitReports})));

const NewDoctorVisitReportsNavigation = [
  {
    path: ROUTE_NEW_DOCTOR_VISIT_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <NewDoctorVisitReports />
      </Suspense>
    ),
  },
];

export default NewDoctorVisitReportsNavigation;
